import { messages as englishMessages } from '@/translate/languages/en';
import { messages as portugueseMessages } from '@/translate/languages/pt';

const messages = {
  ...portugueseMessages,
  ...englishMessages,
};

export { messages };
